
/**
 * @fileOverview AjaxLoader Module File this file allows you to load content into a specified div via an ajax call
 * @modified 11/21/2014
 *
 */
(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/AjaxLoader',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

        /**
         * Sample ajax call, this file should be removed when true ajax calls are constructed.
         *
         * @class AjaxLoader
         * @param {jQuery} trigger Reference to triggering element.
         * @constructor
         *
         * @since 1.0
         */
        var AjaxLoader = function (trigger) {
            this.$trigger = $(trigger);
            this.settings = undefined;
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @method init
         * @returns {AjaxLoader}
         * @private
         */
        AjaxLoader.prototype.init = function () {
            this.isEnabled = false;

            return this.setOptions()
                .setupHandlers()
                .enable();
        };

        /**
         *
         * This takes in data options from the markup and overwrites base values. If there is no value in the data
         * options tag then defaults are shown below.
         *
         * @method setOptions
         * @returns {AjaxLoader}
         * @private
         */

        AjaxLoader.prototype.setOptions = function () {
            var options = this.$trigger.data();

            var defaults = {
                target: undefined,
                workingClass: 'MMM--isActive',
                contentfilter : undefined
            };
            this.settings = $.extend({}, defaults, options);

            this.$context = $(this.settings.target);
            if (this.settings.url) {
                this.url = this.settings.url;
            }
            else {
                this.url = this.$trigger.attr('href');
            }

            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @method setupHandlers
         * @returns {AjaxLoader}
         * @private
         */
        AjaxLoader.prototype.setupHandlers = function () {

            var self = this;
            this.$trigger.on('click', function(e) {
                self.ajaxCall(this, e);
            });

            return this;
        };

        /**
         * Creates a false Ajax adds with error handling. It activates the
         * loader first and then if there is no error it returns and appends
         * the results, then on completion deactivates the loader.
         *
         * @method ajaxCall
         * @returns {AjaxLoader}
         * @private
         */

        AjaxLoader.prototype.ajaxCall = function (trigger, event) {
            var self = this;
            //needed for IE Support
            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
            $debug('************* AJAXLoader Clicked ****************', 'ajax');
            $.ajax({
                beforeSend: self.activateLoader(),
                error: function(error) {
                    $debug('AJAXLoader Error: ' + error, 'ajax');
                    self.deactivateLoader();
                },
                url: self.url,
                success: function (results, textStatus, xhr) {
                    $debug('AJAXLoader Success', 'ajax');
                    $debug('AJAXLoader URL : ' + self.settings.url, 'ajax');
                    $debug('AJAXLoader Target : ' + self.settings.target, 'ajax');
                    $debug('AJAXLoader contentfilter : ' + self.settings.contentfilter, 'ajax');
                    $debug('AJAXLoader: use ?debug=ajax-results to see the full result set', 'ajax');
                    $debug('AJAXLoader results = ' + results, 'ajax-results');
                    if (self.settings.contentfilter !== undefined) {
                        $debug('AJAXLoader contentFilter is present', 'ajax');
                        self.$context.append($(results).find(self.settings.contentfilter).html());
                    }
                    else {
                        $debug('AJAXLoader contentFilter not present', 'ajax');
                        self.$context.append(results);
                    }
                    if (typeof ajaxLoaderCustomSuccess  === 'function'){
                        $debug('AJAXLoader Custom Success Function Present - firing it now', 'ajax');
                        ajaxLoaderCustomSuccess(results, textStatus, xhr);
                    }
                },
                complete: function () {
                    self.deactivateLoader();
                    $debug('************* AJAXLoader Complete ***************', 'ajax');
                }
            });

            return this;
        };


        /**
         * Adds an active class to trigger while ajax call is being made. Calls optional loader function that can be defined elsewhere
            Example:
            function ajaxLoaderCustomLoad(el){
                //el = jQuery object that triggered
                el.hide();
            }
         */
        AjaxLoader.prototype.activateLoader = function () {
            if (typeof ajaxLoaderCustomLoad  === 'function'){
                $debug('AJAXLoader Custom Load Present - firing it now', 'ajax');
                ajaxLoaderCustomLoad(this.$trigger);
            }
            $debug('AJAXLoader Adding Class of ' + this.settings.workingClass + ' to element', 'ajax');
            this.$trigger.addClass(this.settings.workingClass); //adds a class after clicked, but before the results are displayed
            this.disable();
        };

        /**
         * Removes active class from trigger when ajax call is complete. Calls optional cleanup function that can be defined elsewhere
           Example:
            function ajaxLoaderCustomCleanup(el, ){
                //el = jQuery object that triggered
                el.show();
            }
         */
        AjaxLoader.prototype.deactivateLoader = function () {
            if (typeof ajaxLoaderCustomCleanup  === 'function'){
                $debug('AJAXLoader Custom CleanUp Present - firing it now', 'ajax');
                ajaxLoaderCustomCleanup(this.$trigger);
            }
            $debug('AJAXLoader Removing Class of ' + this.settings.workingClass + ' from element', 'ajax');
            this.$trigger.removeClass(this.settings.workingClass); //adds a class after clicked, but before the results are displayed
            this.enable();
        };

        /**
         * Enables the module
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {AjaxLoader}
         * @public
         */
        AjaxLoader.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            }
            $debug('AJAXLoader.js loaded/enabled for ' + this.$trigger.data('url'), 'ajax');
            this.isEnabled = true;
            return this;
        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @method disable
         * @returns {AjaxLoader}
         * @public
         */
        AjaxLoader.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }
            $debug('AJAXLoader.js disabled');
            this.isEnabled = false;
            return this;
        };

        return AjaxLoader;
    });

}(MMMRequire));

